import React, { useState, useEffect, useRef, useCallback } from 'react'

const COUNTDOWN_FROM = 10

const PlayNextOverlay = ({ nextVideo, onPlayNext, onSeeAllEpisodes, isFullscreen = false }) => {
    const [countdown, setCountdown] = useState(COUNTDOWN_FROM)
    const onPlayNextRef = useRef(onPlayNext)

    // Keep ref in sync to avoid stale closures in interval
    useEffect(() => {
        onPlayNextRef.current = onPlayNext
    }, [onPlayNext])

    // Countdown timer
    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval)
                    // Auto-play: not a user gesture
                    onPlayNextRef.current?.(false)
                    return 0
                }
                return prev - 1
            })
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    const handlePlayNextClick = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        // User clicked: is a user gesture (can restore fullscreen)
        onPlayNext?.(true)
    }, [onPlayNext])

    const handleSeeAllClick = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        onSeeAllEpisodes?.()
    }, [onSeeAllEpisodes])

    const thumbnailUrl = nextVideo.thumbnail_large || nextVideo.thumbnail

    if (!thumbnailUrl) return null

    return (
        <div
            className={`play-next-overlay${isFullscreen ? ' is-fullscreen' : ''}`}
            style={{ backgroundImage: `url(${thumbnailUrl})` }}
        >
            <h2 className="play-next-overlay__title">{nextVideo.title}</h2>
            <div className="play-next-overlay__buttons">
                <button
                    className="play-next-overlay__play-next"
                    onClick={handlePlayNextClick}
                >
                    Play Next in {countdown}
                </button>
                <button
                    className="play-next-overlay__see-all"
                    onClick={handleSeeAllClick}
                >
                    See all Episodes
                </button>
            </div>
        </div>
    )
}

export default PlayNextOverlay
